import constant from '../../store/constant'
import config from '../../store/config'
var utils = require('../../utils')

export default {
  name: 'care-office-detail',
  data: function () {
    return {
      careOffice: null,
      careOfficeHisId: null,
      utils: utils,

      // 確認ダイアログ用
      confirmTitle: '',
      confirmMessage: '',
      confirmOnYes: () => {},
      confirmOnNo: () => {},
      searchCallbackFlag: false, // 検索結果フラグ
      /** 画像タイトル編集 */
      editImageTitle: null
    }
  },

  created: function () {
    // システム管理者 または 薬剤師
    this.$store.dispatch('USER_ADMIN_PHARMACIST')

    this.search()
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.googleMapEventRemove() // google map イベント削除
    next()
  },

  computed: {
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    loading() {
      return this.$store.getters.apiLoading
    },
    /** 通知 */
    notify() {
      return this.$store.getters.careOfficeNotify
    },
    /** マスター */
    mCareOffice() {
      return this.$store.getters.mCareOffice
    },
    images() {
      return this.$store.getters.images
    },
    careOfficeHistories() {
      return this.$store.getters.careOfficeHistories
    },
    uploadCounter () {
      var total = this.$store.getters.imageUploadTotal
      var current = this.$store.getters.imageUploadCurrent
      if (total < 1 || total === current) {
        return ''
      } else {
        return this.$t('Count', {'Count': current + '/' + total}) + this.$t('Image Upload Successful')
      }
    },
    uploadErrors () {
      return this.$store.getters.imageUploadErrors
    },
    uploadSuccess () {
      return this.$store.getters.imageUploadStatus
    },
    /** 画像登録ボタン 押下可否 */
    canAddImage: function () {
      if (this.images !== null) {
        return this.images.length < constant.place_image_upload_limit
      } else {
        return true
      }
    },
    /** 管理者 または 組織長かつ薬剤師 */
    isAdminOrPharmacistManager() {
      return this.$store.getters.userAdminOrPharmacistManager
    },
    /** 送付方法 */
    sendTypeName() {
      var array = this.sendTypeToArray(this.careOffice.send_type)
      var ret = ''
      for (var v of array) {
        ret += this.$t('send-type.' + v) + ' '
      }
      return ret
    },
    sendTimingName() {
      var id = this.careOffice.send_timing
      var name = this.searchI18nText('report.send_timing', id)
      if (id == 0) {
        name += ' ' + this.searchI18nText('report.send_timing_hour', this.careOffice.send_timing_hour)
      }
      return ' ' + name
    },
    /** 伏字対応 */
    fuseziName() {
      return this.careOffice.fusezi_flag == 0 ? this.$t('report.fusezi_nashi') : this.$t('report.fusezi_ari')
    },
  },

  methods: {
    /** 初期表示 */
    search: function () {
      this.clearCareOffice()
      var data = {
        careOfficeId: this.$route.params.careOfficeId
      }
      this.searchCallbackFlag = false
      this.$store.dispatch('CARE_OFFICE_SEARCH_DETAIL', { data: data, callback: this.onGetHistories })
    },
    onGetHistories: function(histories) {
      if (histories === null) {
        // this.searchCallbackFlag = true
        this.goPrev()
        return
      }
      if (!histories || histories.length < 1) {
        this.goPrev()
      } else {
        var exists = false
        for (var o of histories) {
          if (o.current_flag) {
            this.careOffice = o
            this.careOfficeHisId = o.careoffice_history_id
            exists = true
          }
        }
        // 当日日付が見つからない場合先頭
        if (!exists) {
          if (histories !== null && histories.length > 0) {
            this.careOffice      = histories[0]
            this.careOfficeHisId = histories[0].careoffice_history_id
          }
        }
        this.googleMapRender()
      }
      this.searchCallbackFlag = true
    },
    clearCareOffice: function () {
      this.careOffice = null
      this.careOfficeHisId = null
      this.$store.dispatch('CARE_OFFICE_DETAIL_CLEAR')
    },

    /** グーグルマップを表示 */
    googleMapRender: function () {
      if (!this.careOffice) {
        return
      }
      var address = ''
      if (utils.isPresent(this.careOffice.address1)) {
        address += this.careOffice.address1
      }
      if (utils.isPresent(this.careOffice.address2)) {
        address += this.careOffice.address2
      }
      var markaList = [{
        lat:     this.careOffice.map_lat,
        lng:     this.careOffice.map_lng,
        zoom:    this.careOffice.map_zoom,
        title:   this.careOffice.careoffice_name,
        address: address,
      }]
      utils.googleMapMarkaOnlyEvent({
        js:          constant.js.google_maps,
        key:         config.google_map_api_key,
        mapElmId:    'map',
        map_default: constant.map_default,
        markaList:   markaList,
      })
    },

    /** 画像タイトルリンク押下 */
    onClickTitleEditModalShow: function (image) {
      this.selectedImage = image
      this.editImageTitle = image.title
      this.$refs.editTitleBtn.click()
    },

    saveTitle: function () {
      this.selectedImage.title = this.editImageTitle
    },

    removeImage: function (image) {
      if (image) image.del_flag = constant.facility.del_flag.on // 1
    },

    /** 画像登録ボタン 押下 */
    onClickUploadModalShow: function () {
      if (this.canAddImage) {
        var button = document.getElementById('images_upload_modal_button')
        button.click() // モーダル表示 イベント発火
        this.uploadStart()
      }
    },

    uploadStart: function () {
      this.$store.dispatch('IMAGE_UPLOAD_START')
    },

    upload: function (files) {
      if (!files)
        return
      if (!this.canAddImage)
        return
      for (var i=0; i<files.length; i++) {
        var formData = new FormData()
        formData.append('image_attach[cache_id]', files[i])
        this.$store.dispatch('IMAGE_UPLOAD', { data: formData, callback: this.onUpload })
      }
    },
    onUpload: function (data) {
      var img = {}
      img.id              = null
      img.title           = data.title
      img.image_attach_id = null
      img.cache_id        = data.cache_id
      img.cache_id_cache  = data.cache_id_cache
      img.image_path      = data.image_path
      img.del_flag        = constant.facility.del_flag.off
      this.images.push(img)
    },
    onDragOver: function (event) {
      var files = event.dataTransfer.items
      if (files && (!this.canAddImage)) {
        event.dataTransfer.dropEffect = "none"
      }
      event.preventDefault()
    },
    onDrop: function (event) {
      // ブラウザ上でファイルを展開する挙動を抑止
      event.preventDefault()

      // ドロップされたファイルのfilesプロパティを参照
      if (this.canAddImage) {
        var files = event.dataTransfer.files
        this.upload(files)
      }
    },
    onFileChange: function (event) {
      // ドロップされたファイルのfilesプロパティを参照
      var files = event.target.files
      this.upload(files)
    },

    onClickSave: function () {
      var data = {
        careoffice_id:this.careOffice.careoffice_id,
        images:       this.images
      }
      this.$store.dispatch('CARE_OFFICE_IMAGE_EDIT', {data: data, callback: this.onSaved})
    },

    onSaved: function () {
      this.$router.push({path: '/care_offices/' + this.$route.params.careOfficeId, query: {type: this.$router.currentRoute.query.type}})

    },

    /** タブ切り替え */
    goFacilities: function () {
      this.$router.push({ path: '/facilities', query: { type: this.$router.currentRoute.query.type } })
    },
    goFacilityPersons: function () {
      this.$router.push({ path: '/facility_persons', query: { type: this.$router.currentRoute.query.type } })
    },
    goDoctors: function () {
      this.$router.push({ path: '/doctors', query: { type: this.$router.currentRoute.query.type } })
    },
    goClinics: function () {
      this.$router.push({ path: '/clinics', query: { type: this.$router.currentRoute.query.type } })
    },
    goCareManagers: function () {
      this.$router.push({ path: '/care_managers', query: { type: this.$router.currentRoute.query.type } })
    },
    goCareOfficesCareman: function () {
      this.$router.push({ path: '/care_managers/list/' + this.$route.params.careOfficeId, query: { type: this.$router.currentRoute.query.type } })
    },

    /** 基準日 */
    getReferenceDate: function (d) {
      if (d.current_flag) {
        // 当日が含まれている場合
        return this.$t('history.today')
      }
      var start = this.getWareki(d.start_date)
      var end = this.getWareki(d.end_date)
      if (end != '') {
        if (new Date(d.end_date).getFullYear() == this.$t('history.max_year')) {
          end = this.$t('history.max_display')
        }
      }
      return start + this.$t('history.delimiter') + end
    },
    changeSelectDate: function () {
      for (var o of this.careOfficeHistories) {
        if (o.careoffice_history_id == this.careOfficeHisId) {
          this.careOffice = o
          this.googleMapRender()
          return
        }
      }
    },

    /** ログイン・パスワード通知 */
    onClickSendMail: function () {
      var type = this.careOffice.send_type
      if (!(type & constant.send_type.fax || type & constant.send_type.email)) {
        this.$store.dispatch('CARE_OFFICE_NOTIFY', {message: this.$t('care_office.no_select_mail_or_fax_message'), danger: true})
        return
      }

      this.confirmTitle = this.$t('care_office.loginid_password_notice')
      this.confirmMessage = this.$t('care_office.loginid_password_notice_confirm')
      this.confirmOnYes = this.sendMedinfo
      this.confirmOnNo = () => {}
      this.$refs.confirmBtn.click()
    },
    sendMedinfo: function() {
      var data = {
        careoffice_id: this.careOffice.careoffice_id,
        careoffice_history_id: this.careOffice.careoffice_history_id,
        shop_id: this.$store.getters.currentShopId
      }
      this.$store.dispatch('CARE_OFFICE_SEND_MEDINFO', { data: data })
    },
    /** ログインID・パスワード通知PDF印刷 */
    onPrintNotifyPDF: function() {
      // 新規ウィンドウ
      var win = window.open(constant.html.loading)
      var data = {
        'shop_id':                 this.$store.getters.currentShopId,
        'careoffice_id':           this.careOffice.careoffice_id,
        'careoffice_history_id':   this.careOffice.careoffice_history_id
      }

      this.$store.dispatch('CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF', {data: data, callback:this.onPrintNotifyPDFCallback, win:win})
    },
    /** ログインID・パスワード通知PDF印刷印刷コールバック */
    onPrintNotifyPDFCallback: function(data, win) {
      win.location.href = data.download
      // 後始末
      setTimeout(() => {
        this.$store.dispatch('CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_DELETE', {data: {delete_path: data.delete_path}})
      }, constant.print_delete_time)
    },
    /** 画像押下 */
    onClickImageModalShow: function (image) {
      var button = document.getElementById('imageModalButton')
      var img    = document.getElementById('imageModalImg')
      var text   = document.getElementById('imageModalText')
      img.src = image.image_path + '?token=' + this.authToken
      text.textContent = image.title
      button.click() // モーダル表示 イベント発火
    },

    /** 取引中止ボタン / 取引再開ボタン */
    onClickEnable: function(enable_flag) {
      var data = {
        careoffice_id: this.careOffice.careoffice_id,
        careoffice_history_id: this.careOffice.careoffice_history_id,
        enable_flag: enable_flag
      }
      utils.googleMapEventRemove()
      this.$store.dispatch('CARE_OFFICE_SET_ENABLE', {data: data, callback: this.onSetEnable})
    },
    onSetEnable () {
      this.googleMapRender()
    },

    /** 編集ボタン */
    goCareOfficeEdit: function () {
      this.$router.push({ path: '/care_offices/edit/' + this.careOfficeHisId, query: { type: this.$router.currentRoute.query.type } })
    },

    /** 削除ボタン */
    onClickDelete: function () {
      this.confirmTitle = this.$t('care_office.delete_confirm')
      this.confirmMessage = this.$t('care_office.delete_confirm_text')
      this.confirmOnYes = this.deleteHistory
      this.confirmOnNo = () => {}
      this.$refs.confirmBtn.click()
    },
    deleteHistory: function () {
      var data = {
        historyId: this.careOfficeHisId
      }
      this.$store.dispatch('CARE_OFFICE_DELETE', { data: data, callback: this.onDeleteHistory })
    },
    onDeleteHistory: function () {
      this.search()
    },

    /** 戻るボタン */
    goPrev: function () {
      this.$router.push({ path: '/care_offices', query: { type: this.$router.currentRoute.query.type, keep: 'true'} })
    },

    /** 日付 (和暦) 用 */
    getWareki: function (seireki_str) {
      if ((!seireki_str) || isNaN(Date.parse(seireki_str))) {
        return ''
      } else {
        return utils.sereki2Wareki(this.$t, new Date(Date.parse(seireki_str)))
      }
    },
    /** 送付方法 */
    sendTypeToArray: function (type) {
      var array = []
      for (var v of [constant.send_type.postal, constant.send_type.fax, constant.send_type.email]) {
        if (type & v) array.push(v)
      }
      return array
    },
    /** I18n内の指定KEYより、指定IDのTEXTを取得 */
    searchI18nText: function (key, id) {
      var arr = this.$t(key)
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].id == id) {
          return arr[i].text
        }
      }
      return ''
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/care-office-detail.js